import * as React from 'react';
import { useActions } from '../../View/viewActions';
import { debounce } from '../../../utils/index';
import { useSelector } from '../../../utils/useSelector';

export const SeeMoreFilters = () => {
  const refId = useSelector(s => s.view?.selected?.props?.refId);
  const userSettings = useSelector(s => s.planning?.userSettings);
  const { setViewSettings } = useActions();
  const userSetting = userSettings[refId];
  const seeMoreFilters = userSetting?.props?.seeMoreFilters || false;

  const handleClick = debounce(() => {
    setViewSettings({ seeMoreFilters: !seeMoreFilters });
  }, 500);

  return (
    <div
      className="see-filters"
      onClick={e => {
        handleClick();
      }}
    >
      {seeMoreFilters ? 'See less' : 'See more'}
    </div>
  );
};
